{
    document.querySelectorAll(".js-filter-cohesion").forEach(function(tag) {
        tag.addEventListener("click", function(e) {
            let itemOutboundUrl = tag.querySelector("a")?.href || '';
            let filterPosition = String(tag.dataset.position);
            let filterName = tag.dataset.jsfiltername;
            let nameFilter = tag.dataset.name;

            let actionOutcome = tag.classList.contains("selected") ||  tag.classList.contains("current_selected") ? "UNSELECT" : "SELECT";

            tagular('ElementClicked', {
                actionOutcome: actionOutcome,
                outboundUrl: itemOutboundUrl,
                webElement: {
                    elementType: 'Button',
                    htmlId: null,
                    location: 'PLP Filters',
                    name: nameFilter,
                    position: filterPosition,
                    text: filterName,
                    variant: null
                }
            });
        });
    });
}



// Trigger ElementViewed event when filter module becomes visible
{
    const filterModule = document.querySelector('.collection-tag-filter-wrapper');

    if (filterModule) {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
        if (entry.isIntersecting) {
            tagular('ElementViewed', {
            actionOutcome: null,
            outboundUrl: null, 
            webElement: {
                elementType: 'Button',
                htmlId: null,
                location: 'PLP Filters',
                name: null,
                position: null,
                text: null,
                variant: null
            }
            });

            observer.unobserve(filterModule); // Ensure it fires only once
        }
        });
    }, {
        threshold: 0.5 // 50% of the module should be visible before triggering
    });

    observer.observe(filterModule);
    }
}


{
const searchInput = document.querySelector('.search-container input');

// Fire ElementClicked when input is focused (clicked into)
if (searchInput) {
  searchInput.addEventListener('focus', function () {
    tagular('ElementClicked', {
      actionOutcome: 'SEARCH',
      outboundUrl: window.location.href, // current page URL
      webElement: {
        elementType: 'Text Field',
        htmlId:  null,
        location: 'PLP Filters',
        name: 'Search Bar',
        position: "5",
        text: '',
        variant: null
      }
    });
  });
}
}


{
  const clearButton = document.querySelector(".clear_button");

  if (clearButton) {
    clearButton.addEventListener("click", (e) => {
      let clearButtonName = clearButton.innerText || "Clear All Filters";

      tagular("ElementClicked", {
        actionOutcome: "UNSELECT",
        outboundUrl: null,
        webElement: {
          elementType: "Button",
          htmlId: null,
          location: "PLP Filters",
          name: clearButtonName,
          position: null,
          text: null,
          variant: null,
        },
      });
    });
  }
}
